import { io, Socket } from 'socket.io-client';
import { API_URL } from '../constants';

class WebSocketService {
  private socket: Socket | null = null;
  private userId: string | null = null;
  private listeners: Map<string, Function[]> = new Map();

  connect(userId: string) {
    if (this.socket && this.socket.connected && this.userId === userId) {
      return;
    }

    this.userId = userId;
    // Use the same URL as API for WebSocket connection
    this.socket = io(API_URL, {
      transports: ['websocket', 'polling']
    });

    this.socket.on('connect', () => {
      console.log('Connected to WebSocket server');
      if (this.socket && this.userId) {
        this.socket.emit('join', this.userId);
      }
    });

    this.socket.on('disconnect', () => {
      console.log('Disconnected from WebSocket server');
    });

    this.socket.on('newPost', (data) => {
      console.log('New post notification:', data);
      this.emit('newPost', data);
    });

    this.socket.on('newNotification', (data) => {
      console.log('New notification:', data);
      this.emit('newNotification', data);
    });
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      this.userId = null;
      this.listeners.clear();
    }
  }

  on(event: string, callback: Function) {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, []);
    }
    this.listeners.get(event)!.push(callback);
  }

  off(event: string, callback?: Function) {
    if (!this.listeners.has(event)) {
      return;
    }

    if (callback) {
      const callbacks = this.listeners.get(event)!;
      const index = callbacks.indexOf(callback);
      if (index > -1) {
        callbacks.splice(index, 1);
      }
    } else {
      this.listeners.set(event, []);
    }
  }

  private emit(event: string, data: any) {
    if (this.listeners.has(event)) {
      this.listeners.get(event)!.forEach(callback => {
        try {
          callback(data);
        } catch (error) {
          console.error('Error in WebSocket callback:', error);
        }
      });
    }
  }

  isConnected(): boolean {
    return this.socket ? this.socket.connected : false;
  }
}

const websocketService = new WebSocketService();
export default websocketService;